import React from "react";
import SelectBox from "../../common/SelectBox";
import TextField from "../../common/TextField";
import Button from "../../common/Button";

const SearchBar = ( props ) => {

  const changeSearchKeyword = ( event ) => {
    props.onChangeSearchKeyword( event.target.value );
  };

  const search = ( event ) => {
    switch ( event.type ) {
      case 'keydown' :
        13 === event.keyCode && props.onSearch();
        break;
      default :
        props.onSearch();
    }
  };

  return (
    <div className="ss-complex-wrap">
      <SelectBox className="ss-complex-item new-select" data={ props.languageData } value={ props.language } onChange={ props.onChangeLanguage } />
      <SelectBox className="ss-complex-item new-select" data={ props.searchTypeData } value={ props.searchType } onChange={ props.onChangeSearchType } />
      <div className="ss-complex-item input_cont">
        <TextField className="gray_box" placeholder="검색어 입력" value={ props.searchKeyword } onChange={ changeSearchKeyword } onKeyDown={ search } />
      </div>
      <Button className="ss-complex-item btn btn-blue h48" onClick={ search }>검색</Button>
    </div>
  );

};

SearchBar.defaultProps = {
  onChangeSearchKeyword : () => {},
  onSearch : () => {}
};

export default SearchBar;
